import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../../../button/button.module';
import { TooltipModule } from '../../../tooltip/tooltip.module';
import { MapToolListComponent } from './map-tool-list.component';

@NgModule({
  imports: [CommonModule, ButtonModule, TooltipModule],
  declarations: [MapToolListComponent],
  exports: [MapToolListComponent],
})
export class MapToolListModule {}
